import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { SupplementInfoField } from '../../types';
import { isEmptyFieldValue } from '../../utils';

@Component({ name: 'PreTaxMonthSalary' })
export default class PreTaxMonthSalary extends Vue implements SupplementInfoField {
  @Prop()
  private value!: undefined | number;

  private preTaxMonthSalary: undefined | number | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    if (this.value) {
      this.preTaxMonthSalary = this.value;
    }

    this.options = await DictApi.getIncomeType();
  }

  @Watch('value')
  private onPropsValueChange(val: undefined | number) {
    this.preTaxMonthSalary = val;
  }

  public onValidator(): boolean {
    if (isEmptyFieldValue(this.value)) {
      this.errorMsg = '请选择月薪';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChange(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="月薪"
        errorMessage={this.errorMsg}
      >
        <SelectInput
          v-model={this.preTaxMonthSalary}
          title="选择月薪"
          placeholder="选择月薪"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChange}
        />
      </Field>
    );
  }
}
